// styles
import { TitlePage, Containers, DivBtn } from "./styles";

//hooks
import React, {useState, useEffect} from "react";
import { useAuthentication } from "../../hooks/useAuthentication";

//components
import ButtonDefault from "../../components/Buttons";

const Register = () => {
    const [displayName, setDisplayName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");

    const {createUser, error: authError, loading} = useAuthentication();

    const handleSubmit = async (e) => {
        e.preventDefault();

        setError("");

        const user = {
            displayName,
            email,
            password,
        };

        if(password !== confirmPassword) {
            setError("Passwords need to be the same!");
            return
        }

        const res = await createUser(user);

        console.log(res);
    };

    useEffect(() => {
        if(authError) {
            setError(authError)
        }
    }, [authError]);

    return (
        <>
        <Containers>
        <TitlePage>Register</TitlePage>
        <p>Create your user and share your stories.</p>
        <form onSubmit={handleSubmit}>
            <label>
                <span>Name:</span>
                <input type="text"
                name="displayName"
                required
                placeholder="Username"
                value={displayName}
                onChange={(e) => setDisplayName(e.target.value)}
                />

            </label>

            <label>
                <span>E-mail:</span>
                <input type="email"
                name="email"
                required
                placeholder="User email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                />

            </label>

            <label>
                <span>Password:</span>
                <input type="password"
                name="password"
                required
                placeholder="Enter your password."
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                />
              

            </label>

            
            <label>
                <span>Confirm your password:</span>
                <input type="password"
                name="confirmPassword"
                required
                placeholder="Confirm your password."
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                />

            </label>

            <DivBtn>
             <center>
            {!loading && <ButtonDefault
            type={"confirm"} name={"Register"}/>}
            {loading && (
            <ButtonDefault
            type={"confirm"} name={"Wait..."}/>
            )}
            {error && <p className="error">{error}</p>}
            </center>
            </DivBtn>
        </form>
        </Containers>
        </>
    );
};

export default Register;